<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <!-- INÍCIO INSCRIÇÃO -->
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img src="../../assets/logoInteliteAzul.png" width="230px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <!-- <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o evento que você deseja participar:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="inscricao.eventoId" :items="eventos" item-text="nome" item-value="id" color="#00695C"></v-select>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha seus dados:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="vigilante.nome" label="NOME COMPLETO" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light label="CPF" color="#00695C" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="vigilante.cpf" @change="consultaCPF"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field type="tel" light v-model="vigilante.dataNascimento" label="DATA DE NASCIMENTO" single-line outlined color="#00695C" required v-mask="'##/##/####'" dense hide-details :error-messages="errors.collect('dateOfBirth')" return-masked-value mask="##/##/####" data-vv-name="dateOfBirth"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-select outlined dense v-model="vigilante.sexo" :items="sexo" hide-details item-text="titulo" item-value="id" color="#00695C" label="SEXO"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light label="TELEFONE" color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required v-model="vigilante.telefone"></v-text-field>
                    </v-flex>
                   <!--  <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="vigilante.email" label="E-MAIL" outlined color="#00695C" :rules="[rules.required, rules.email]" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha seu endereço:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="vigilante.cep" label="CEP" single-line outlined color="#00695C" dense hide-details required v-mask="'#####-###'"  @blur="retornoCEP()" append-outer-icon="search" type="tel"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="cepNotCaptured">
                      <v-select outlined dense v-model="vigilante.estado" :items="estados" hide-details item-text="text" item-value="value" color="#00695C" label="ESTADO" @change="carregaMunicipios()"></v-select>
                    </v-flex>
                     <v-flex xs12 sm12 lg3 v-else>
                      <v-text-field light v-model="vigilante.estado" label="ESTADO" single-line outlined color="#00695C" dense hide-details required disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="cepNotCaptured">
                      <v-select outlined dense v-model="vigilante.cidade" :items="municipios" hide-details item-text="text" item-value="value" color="#00695C" label="CIDADE" :disabled="informaMunicipio"></v-select>
                    </v-flex>                   
                    <v-flex xs12 sm12 lg3 v-else>
                      <v-text-field light v-model="vigilante.cidade" label="CIDADE" single-line outlined color="#00695C" dense hide-details required disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="vigilante.bairro" label="BAIRRO" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg10>
                      <v-text-field light v-model="vigilante.logradouro" label="RUA" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-text-field light v-model="vigilante.numero" label="Nº" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
<!--                     <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha suas informações:</p>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg3>
                      <v-select outlined dense v-model="vigilante.qualificacao" :items="qualificacoes" hide-details item-text="titulo" item-value="id" color="#00695C" label="QUALIFICAÇÃO"></v-select>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4 v-if="vigilante.qualificacao!='APOIO'">
                      <v-text-field type="tel" light v-model="vigilante.validadeCurso" label="VENCIMENTO RECICLAGEM" single-line outlined color="#00695C" dense hide-details required v-mask="'##/##/####'"></v-text-field>
                    </v-flex> -->
                    <!-- <v-flex xs12 sm12 lg4 style="text-align: center" v-if="vigilante.qualificacao!='APOIO'">
                      <a href="https://servicos.dpf.gov.br/pgdwebcertificado/public/pages/pessoa/consultarSituacaoPessoa.jsf" target="_blank" style="text-decoration: none">Clique aqui para consultar sua reciclagem</a>
                    </v-flex> -->
                   <!--  <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Faça o envio das imagens:</p>
                    </v-flex> -->
                    <!-- COMPROVANTE RECICLAGEM -->
                    <!-- <v-flex xs12 sm12 lg4 style="text-align: center" v-if="vigilante.qualificacao!='APOIO'">
                      <file-upload
                        class="btn btn-primary"
                        input-id="file5"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesReciclagem"
                        @input-filter="inputFilter"
                        @input-file="inputFileReciclagem"
                        ref="upload5"
                      >
                        <p class="form-titulo" style="font-size: 15px">COMPROVANTE RECICLAGEM</p>
                        <v-btn
                          style="border-radius: 8px;"
                          dark
                          color="#4A148C"
                        >Selecionar arquivo</v-btn>
                        <p id="reciclagem" value="" hidden></p>     
                        <p v-if="filesReciclagem == ''">Nenhum arquivo selecionado</p>
                        <div v-else>
                          <p v-for="(file) in filesReciclagem" :key="file.id">{{file.name}}</p>
                        </div>              
                      </file-upload>
                    </v-flex> -->
                    <!-- RG FRENTE -->
                    <!-- <v-flex xs12 sm12 lg6 style="text-align: center">
                      <p class="form-titulo" style="font-size: 15px">RG/CNH (FRENTE)</p>
                      <v-btn v-if="vigilante.arquivoRgFrente == ''" @click="uploadCnhRgFrente = true" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                      <img v-else width="120px" :src="vigilante.arquivoRgFrente" alt="arquivoRgCnhFrente" @click="uploadCnhRgFrente = true" />
                    </v-flex> -->
                    <!-- RG VERSO -->
                    <!-- <v-flex xs12 sm12 lg6 style="text-align: center">
                      <p class="form-titulo" style="font-size: 15px">RG/CNH (VERSO)</p>
                      <v-btn v-if="vigilante.arquivoRgVerso == ''" @click="uploadCnhRgVerso = true" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                      <img v-else width="120px" :src="vigilante.arquivoRgVerso" alt="arquivoRgCnhVerso" @click="uploadCnhRgVerso = true" />
                    </v-flex> -->
                    <!-- CPF -->
                    <!-- <v-flex xs12 sm12 lg6 style="text-align: center">
                      <p class="form-titulo" style="font-size: 15px">CPF</p>
                      <v-btn v-if="vigilante.arquivoCpf == ''" @click="uploadCpf = true" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                      <img v-else width="120px" :src="vigilante.arquivoCpf" alt="arquivoCpf" @click="uploadCpf = true" />
                    </v-flex> -->
                    <!-- FOTO PESSOAL -->
                   <!--  <v-flex xs12 sm12 lg6 style="text-align: center">
                      <p class="form-titulo" style="font-size: 15px">FOTO PESSOAL</p>
                      <v-btn v-if="vigilante.arquivoFotoPessoal == ''" @click="uploadFotoPessoal = true" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                      <img v-else width="120px" :src="vigilante.arquivoFotoPessoal" alt="arquivoCpf" @click="uploadFotoPessoal = true" />
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg6>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="inscricaoVigilante">Confirmar Inscrição</v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn dark depressed block color="#E53935" style="border-radius: 7px;" large @click="solicitaCancelamento">Solicitar Cancelamento</v-btn>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAIPassIntelite.png" width="250px">
          </a>
        </div>
        <!-- FIM INSCRIÇÃO -->
        <!-- MENSAGEM FINAL -->
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{vigilante.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">Seu cadastro será analisado e aprovado em até 24 horas. Após este período, você poderá se voluntariar para os eventos.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">SEU CÓDIGO É: <span style="color:#EF6C00">{{codigoGerado}}</span></p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIM MENSAGEM FINAL -->
        <!-- DIÁLOGO DE CANCELAMENTO -->
        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{vigilante.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">CPF : {{vigilante.cpf}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{eventoSelecionado}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="background-color: #D32F2F;color: white;">Confirme a sua solicitação de cancelamento</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="realizarCancelamento">confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIM DIÁLOGO DE CANCELAMENTO -->
        <!-- DIÁLOGO ENVIO FRENTE RG/CNH -->
        <v-dialog v-model="uploadCnhRgFrente" max-width="550px" max-height="300px" persistent> 
          <v-card style="border-radius: 10px;">
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-container fill-height fluid pa-1 justify-center>
                  <vueAnkaCropper
                    :options="{
                      aspectRatio: 0,
                      closeOnSave: true,
                      cropArea: 'box',
                      croppedHeight: 500,
                      croppedWidth: 500,
                      cropperHeight: false,
                      dropareaMessage: 'Insira aqui uma imagem da frente de seu RG/CNH',
                      frameLineDash: [0,0],
                      frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      handleFillColor: 'rgba(255, 255, 255, 0.2)',
                      handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                      handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                      handleSize: 10,
                      handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      layoutBreakpoint: 500,
                      maxCropperHeight: 768,
                      maxFileSize: 8000000,
                      overlayFill: 'rgba(0, 0, 0, 0.5)',
                      previewOnDrag: false,
                      previewQuality: 0.65,
                      resultQuality: 0.9,
                      resultMimeType: 'image/jpeg',
                      selectButtonLabel: 'Escolher imagem',
                      showPreview: false,
                      skin: 'light',
                      uploadData: {},
                      uploadTo: false
                    }"
                    @cropper-error="erroCorte($event)"
                    @cropper-saved="salvarCorte($event, 1)"
                    @cropper-cancelled="cancelaCorte()"
                  ></vueAnkaCropper>
                </v-container>
              </v-layout>
              <v-card-actions>
                <v-container fill-height fluid pa-1 justify-center>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadCnhRgFrente = false">Fechar</v-btn>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
        <!-- DIÁLOGO ENVIO VERSO RG/CNH -->
        <v-dialog v-model="uploadCnhRgVerso" max-width="550px" max-height="300px" persistent> 
          <v-card style="border-radius: 10px;">
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-container fill-height fluid pa-1 justify-center>
                  <vueAnkaCropper
                    :options="{
                      aspectRatio: 0,
                      closeOnSave: true,
                      cropArea: 'box',
                      croppedHeight: 500,
                      croppedWidth: 500,
                      cropperHeight: false,
                      dropareaMessage: 'Insira aqui uma imagem do verso de seu RG/CNH',
                      frameLineDash: [0,0],
                      frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      handleFillColor: 'rgba(255, 255, 255, 0.2)',
                      handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                      handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                      handleSize: 10,
                      handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      layoutBreakpoint: 500,
                      maxCropperHeight: 768,
                      maxFileSize: 8000000,
                      overlayFill: 'rgba(0, 0, 0, 0.5)',
                      previewOnDrag: false,
                      previewQuality: 0.65,
                      resultQuality: 0.9,
                      resultMimeType: 'image/jpeg',
                      selectButtonLabel: 'Escolher imagem',
                      showPreview: false,
                      skin: 'light',
                      uploadData: {},
                      uploadTo: false
                    }"
                    @cropper-error="erroCorte($event)"
                    @cropper-saved="salvarCorte($event, 2)"
                    @cropper-cancelled="cancelaCorte()"
                  ></vueAnkaCropper>
                </v-container>
              </v-layout>
              <v-card-actions>
                <v-container fill-height fluid pa-1 justify-center>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadCnhRgVerso = false">Fechar</v-btn>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
        <!-- DIÁLOGO ENVIO CPF -->
        <v-dialog v-model="uploadCpf" max-width="550px" max-height="300px" persistent> 
          <v-card style="border-radius: 10px;">
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-container fill-height fluid pa-1 justify-center>
                  <vueAnkaCropper
                    :options="{
                      aspectRatio: 0,
                      closeOnSave: true,
                      cropArea: 'box',
                      croppedHeight: 500,
                      croppedWidth: 500,
                      cropperHeight: false,
                      dropareaMessage: 'Insira aqui uma imagem do CPF',
                      frameLineDash: [0,0],
                      frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      handleFillColor: 'rgba(255, 255, 255, 0.2)',
                      handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                      handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                      handleSize: 10,
                      handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      layoutBreakpoint: 500,
                      maxCropperHeight: 768,
                      maxFileSize: 8000000,
                      overlayFill: 'rgba(0, 0, 0, 0.5)',
                      previewOnDrag: false,
                      previewQuality: 0.65,
                      resultQuality: 0.9,
                      resultMimeType: 'image/jpeg',
                      selectButtonLabel: 'Escolher imagem',
                      showPreview: false,
                      skin: 'light',
                      uploadData: {},
                      uploadTo: false
                    }"
                    @cropper-error="erroCorte($event)"
                    @cropper-saved="salvarCorte($event, 3)"
                    @cropper-cancelled="cancelaCorte()"
                  ></vueAnkaCropper>
                </v-container>
              </v-layout>
              <v-card-actions>
                <v-container fill-height fluid pa-1 justify-center>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadCpf = false">Fechar</v-btn>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
        <!-- DIÁLOGO ENVIO FOTO PESSOAL -->
        <v-dialog v-model="uploadFotoPessoal" max-width="550px" max-height="300px" persistent> 
          <v-card style="border-radius: 10px;">
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-container fill-height fluid pa-1 justify-center>
                  <vueAnkaCropper
                    :options="{
                      aspectRatio: 1,
                      closeOnSave: true,
                      cropArea: 'box',
                      croppedHeight: 500,
                      croppedWidth: 500,
                      cropperHeight: false,
                      dropareaMessage: 'Insira aqui sua foto pessoal do rosto',
                      frameLineDash: [0,0],
                      frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      handleFillColor: 'rgba(255, 255, 255, 0.2)',
                      handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                      handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                      handleSize: 10,
                      handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                      layoutBreakpoint: 500,
                      maxCropperHeight: 768,
                      maxFileSize: 8000000,
                      overlayFill: 'rgba(0, 0, 0, 0.5)',
                      previewOnDrag: false,
                      previewQuality: 0.65,
                      resultQuality: 0.9,
                      resultMimeType: 'image/jpeg',
                      selectButtonLabel: 'Escolher imagem',
                      showPreview: false,
                      skin: 'light',
                      uploadData: {},
                      uploadTo: false
                    }"
                    @cropper-error="erroCorte($event)"
                    @cropper-saved="salvarCorte($event, 4)"
                    @cropper-cancelled="cancelaCorte()"
                  ></vueAnkaCropper>
                </v-container>
              </v-layout>
              <v-card-actions>
                <v-container fill-height fluid pa-1 justify-center>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadFotoPessoal = false">Fechar</v-btn>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import CpfValidate from '../../componentes/validators/rules/cpf'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
import vueAnkaCropper from 'vue-anka-cropper'
export default {
  components: { Snackbar, Loading, vueAnkaCropper },
  name: 'Auth',
  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
  }),
  data: function () {
    return {
      uploadCnhRgFrente: false,
      uploadCnhRgVerso: false,
      uploadCpf: false,
      uploadFotoPessoal: false,
      mask: "###.###.###-##",
      user: {},
      eventoSelecionado: '',
      vigilante: {
        cod_incricao: '',
        nome: '',
        cpf: '',
        sexo: '',
        telefone: '',
        infoVacina: '',
        logradouro: '',
        numero: '',
        estado: '',
        cidade: '',
        bairro: '',
        email: '',
        dataNascimento: '',
        empresaId: '61a63c2c36a415043173a58d',
        cep: '',
        qualificacao: '',
        validadeCurso: '',
        arquivoCpf: '',
        arquivoCnh: '',
        arquivoRgFrente: '',
        arquivoRgVerso: '',
        arquivoComprovanteReciclagem: '',
        arquivoFotoPessoal: '',
      },
      vigilanteDefault: {
        cod_incricao: '',
        nome: '',
        cpf: '',
        sexo: '',
        telefone: '',
        infoVacina: '',
        logradouro: '',
        numero: '',
        estado: '',
        cidade: '',
        bairro: '',
        email: '',
        dataNascimento: '',
        empresaId: '61a63c2c36a415043173a58d',
        cep: '',
        qualificacao: '',
        validadeCurso: '',
        arquivoCpf: '',
        arquivoCnh: '',
        arquivoRgFrente: '',
        arquivoRgVerso: '',
        arquivoComprovanteReciclagem: '',
        arquivoFotoPessoal: '',
      },
      dialogCancelamento: false,
      dialog: false,
      qtdInscritos: 0,
      capacidadeEvento: 0,
      reserva: 0,
      sexo: ['MASCULINO', 'FEMININO'],
      qualificacoes: ['APOIO', 'VIGILANTE BÁSICO', 'VIGILANTE DE GRANDES EVENTOS'],
      eventos: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: '',
      msgResultado: '',
      idVigilante: '',
      codigoGerado: '',
      informaMunicipio: true,
      cepNotCaptured: true,
      estados: [
          {value: 12, text: "AC"},
          {value: 27, text: "AL"},
          {value: 16, text: "AP"},
          {value: 13, text: "AM"},
          {value: 29, text: "BA"},
          {value: 23, text: "CE"},
          {value: 53, text: "DF"},
          {value: 32, text: "ES"},
          {value: 52, text: "GO"},
          {value: 21, text: "MA"},
          {value: 51, text: "MT"},
          {value: 50, text: "MS"},
          {value: 31, text: "MG"},
          {value: 15, text: "PA"},
          {value: 25, text: "PB"},
          {value: 41, text: "PR"},
          {value: 26, text: "PE"},
          {value: 22, text: "PI"},
          {value: 33, text: "RJ"},
          {value: 24, text: "RN"},
          {value: 43, text: "RS"},
          {value: 11, text: "RO"},
          {value: 14, text: "RR"},
          {value: 42, text: "SC"},
          {value: 35, text: "SP"},
          {value: 28, text: "SE"},
          {value: 17, text: "TO"}
        ],
      municipios: [],
      estadoSelecionado: '',
      dictionary: {          
        custom: {
          dateOfBirth: {
            required: () => 'Informe a data de nascimento',
            date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
          },
        }
      },
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Insira um e-mail válido (apenas minúsculas)'
        },
      },
    }
  },
  mounted: function () {
    this.carregaDados()
    this.$validator.localize('pt', this.dictionary)
  },

  methods: {
    async retornoCEP() {
      if (/^[0-9]{5}-[0-9]{3}$/.test(this.vigilante.cep)) {
        this.isLoading = true
        try {
          let res = await axios.get(`https://viacep.com.br/ws/${this.vigilante.cep.replace(/[^\d]+/g,'')}/json/`) 
          if (res.data.erro == true || res.data.bairro == '' || res.data.localidade == '' || res.data.uf == '') {
            this.isLoading = false
            this.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado! Preencha os campos manualmente.","ATENÇÃO")
            this.vigilante.logradouro = ''
            this.vigilante.estado = ''
            this.vigilante.cidade = ''
            this.vigilante.bairro = ''
            this.cepNotCaptured = true
          } else {
            this.vigilante.logradouro = res.data.logradouro.toUpperCase()
            this.vigilante.estado = res.data.uf.toUpperCase()
            this.vigilante.cidade = res.data.localidade.toUpperCase()
            this.vigilante.bairro = res.data.bairro.toUpperCase()
            this.isLoading = false
            this.cepNotCaptured = false
          }
        } catch (error) {
          this.isLoading = false
          this.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado! Preencha os campos manualmente.","ATENÇÃO")
          this.vigilante.logradouro = ''
          this.vigilante.estado = ''
          this.vigilante.cidade = ''
          this.vigilante.bairro = ''
          this.cepNotCaptured = true
        }
      } else {
        this.isLoading = false
        this.cepNotCaptured = true
      }
    },

    async consultaCPF() {
      this.isLoading = true
      try {
        let res = await axios.get(`${baseApiUrl}Vigilantes/count?where={"cpf":"${this.vigilante.cpf}"}`)
        if (res.data) {
          if (res.data.count == 1) {
            this.isLoading = false
            this.$refs.chamaSnackbar.snack("#F9A825","Já existe uma inscrição para o CPF informado. Entre em contato com a administração!","ATENÇÃO")
          } else {
            this.isLoading = false
          }
        }
      } catch (error) {
        this.isLoading = true
        this.$refs.chamaSnackbar.snack("#F9A825","Problema encontrado ao verificar o CPF","ATENÇÃO")
      }
    },

    async carregaDados() {
      this.isLoading = true
      await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"5ee924d995921b08c6aa931b"},{"ativo":"true"}]}}`).then(res => {
        for (var key in res.data) {
          if (res.data.hasOwnProperty(key)) {
            if (moment(this.formatDateHora(res.data[key].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
              this.eventos.push(res.data[key])
              this.eventoId = res.data[key].id
            }
          }
        }
        this.eventos = this.eventos.sort(this.compare)
        this.isLoading = false
      })
    },

    // método novo de inscrição
    async inscricaoVigilante() {
      var vm = this;
      if ((this.vigilante.nome == '') || (!CpfValidate(this.vigilante.cpf)) || (this.vigilante.sexo == '') || (this.vigilante.telefone == '') || (this.vigilante.dataNascimento == '') || (this.vigilante.qualificacao == '')) {
        vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos!","ATENÇÃO")
      } else {
        try {
          this.vigilante.nome = this.vigilante.nome.toUpperCase()
          this.isLoading = true
          await axios.post(`${baseApiUrl}Vigilantes/salvaVigilante`, this.vigilante).then(res => {
            if (res.data) {
              this.codigoGerado = res.data.codigo
              this.msgResultado = 'Cadastro realizado com sucesso!'
              this.dialog = true
              this.isLoading = false
            }
          })
        } catch (error) {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar inscrição. Tente novamente.", "DESCULPE")
        }
      }
    },

    // método antigo de inscrição
    /* async inscricaoVigilante() {
      var vm = this;
      if (this.vigilante.qualificacao != 'APOIO') {
        if (
          (this.vigilante.nome == '') || (!CpfValidate(this.vigilante.cpf)) || (this.vigilante.sexo == '') || (this.vigilante.telefone == '') ||
          (this.vigilante.logradouro == '') || (this.vigilante.numero == '') || (this.vigilante.email == '') ||
          (this.vigilante.dataNascimento == '') || (this.vigilante.qualificacao == '') || (this.vigilante.cidade == '') || (this.vigilante.estado == '')) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos!","ATENÇÃO")
        } else {
          if (!this.vigilante.arquivoRgFrente || !this.vigilante.arquivoRgVerso || !this.vigilante.arquivoCpf || !this.vigilante.arquivoFotoPessoal) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar, é necessário enviar todos os arquivos!","ATENÇÃO")
          } else {
            this.vigilante.email = this.vigilante.email.trim().toLowerCase()
            this.vigilante.estado = this.estadoSelecionado
            try {
              this.isLoading = true
              await axios.post(`${baseApiUrl}Vigilantes/salvaVigilante`, this.vigilante).then(res => {
                if (res.data) {
                  this.codigoGerado = res.data.codigo
                  this.msgResultado = 'Cadastro realizado com sucesso!'
                  this.dialog = true
                  this.isLoading = false
                }
              })
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar inscrição. Tente novamente.", "DESCULPE")
            }
          }
        }
      } else {
        if (
        (this.vigilante.nome == '') || (!CpfValidate(this.vigilante.cpf)) || (this.vigilante.sexo == '') || (this.vigilante.telefone == '') ||
        (this.vigilante.logradouro == '') || (this.vigilante.numero == '') || (this.vigilante.email == '') ||
        (this.vigilante.dataNascimento == '') || (this.vigilante.qualificacao == '') || (this.vigilante.cidade == '') || (this.vigilante.estado == '')) {        
          vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos!","ATENÇÃO")
        } else {
          if (!this.vigilante.arquivoRgFrente || !this.vigilante.arquivoRgVerso || !this.vigilante.arquivoCpf || !this.vigilante.arquivoFotoPessoal) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar, é necessário enviar todos os arquivos!","ATENÇÃO")
          } else {
            this.vigilante.email = this.vigilante.email.trim().toLowerCase()
            this.vigilante.estado = this.estadoSelecionado
            try {
              this.isLoading = true
              await axios.post(`${baseApiUrl}Vigilantes/salvaVigilante`, this.vigilante).then(res => {
                if (res.data) {
                  this.codigoGerado = res.data.codigo
                  this.msgResultado = 'Cadastro realizado com sucesso!'
                  this.dialog = true
                  this.isLoading = false
                }
              })
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar inscrição. Tente novamente.", "DESCULPE")
            }
          }
        }
      }
    }, */

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    async solicitaCancelamento() {
      this.isLoading = true
      if (this.vigilante.nome == '' || this.vigilante.eventoId == '' || this.vigilante.cpf == '') {
        this.isLoading = false
        this.$refs.chamaSnackbar.snack("#F9A825", "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!", "ATENÇÃO")
      } else {
        this.isLoading = false
        this.dialogCancelamento = true
      }
    },

    async realizarCancelamento() {
      this.idVigilante = ''
      this.isLoading = true
      try {
        let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.vigilante.eventoId}"},{"cpf":"${this.vigilante.cpf}"}]}}`)
        if (res.data[0].id) {
          this.idVigilante = res.data[0].id
        } else {
          this.isLoading = false
          this.dialogCancelamento = false
          this.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
        }
      } catch (error) {
        this.isLoading = false
        this.dialogCancelamento = false
        this.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
      }
      if (this.idVigilante != '') {
        try {
          let res = await axios.delete(`${baseApiUrl}Inscricoes/${this.idVigilante}`)
          if (res.data != '') {
            this.isLoading = false
            this.vigilante = Object.assign({}, this.vigilanteDefault)
            this.dialogCancelamento = false
            this.$refs.chamaSnackbar.snack("#0288D1", "Cancelamento realizado com sucesso!", "INFORMAÇÃO")
          } else {
            this.isLoading = false
            this.dialogCancelamento = false
            this.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        } catch (error) {
          this.isLoading = false
          this.dialogCancelamento = false
          this.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
        }
      }
    },

    closeDialog() {
      this.dialog = false
      this.vigilante = Object.assign({}, this.vigilanteDefault)
      this.$validator.reset()
      window.location.reload()
    },

    async carregaMunicipios() {
        this.isLoading = true
        this.estadoSelecionado
        for (let i = 0; i < this.estados.length; i++) {
          if (this.vigilante.estado == this.estados[i].value) {
            this.estadoSelecionado = this.estados[i].text
          }
        }
        try {
          let res = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.vigilante.estado}/municipios`)
          if (res.data) {
            this.municipios = []

            res.data.forEach(minic => {
              this.municipios.push({
                value: minic.nome,
                text: minic.nome
              })
            });

            this.informaMunicipio = false
            this.isLoading = false
          }
        } catch (error) {
          this.isLoading = false
          this.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar municípios","DESCULPE");
        }
      },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    cancelaCorte() {
      this.uploadCnhRgFrente = false
      this.uploadCnhRgVerso = false
      this.uploadCpf = false
      this.uploadFotoPessoal = false
    },

    async salvarCorte(event, field) {
      this.isLoading = true
      if (field == 1) {
        this.vigilante.arquivoRgFrente = event.croppedImageURI
      }
      else if (field == 2) {
        this.vigilante.arquivoRgVerso = event.croppedImageURI
      }
      else if (field == 3) {
        this.vigilante.arquivoCpf = event.croppedImageURI
      }
      else if (field == 4) {
        this.vigilante.arquivoFotoPessoal = event.croppedImageURI
      }
      this.uploadPhoto = false
      this.uploadCnhRgFrente = false
      this.uploadCnhRgVerso = false
      this.uploadCpf = false
      this.uploadFotoPessoal = false
      this.isLoading = false
      this.$refs.chamaSnackbar.snack("#87F500","Imagem salva!","SUCESSO");
    },

    erroCorte (event) {
      if (event.substring(0,5) == "Wrong") {
        this.$refs.chamaSnackbar.snack("#F9A825","Apenas imagens são permitidas!","ATENÇÃO");
      }
      else if (event.substring(0,4) == "File") {
        this.$refs.chamaSnackbar.snack("#F9A825","Arquivo muito grande. Máximo permitido de 8MB","ATENÇÃO");
      }
    },
  }
}
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #4A148C, #8E24AA);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}

@import '../../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css'
</style>
